import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import Tooltip from 'react-bootstrap/Tooltip';

import './MLTooltip.scss';

const MLTooltip = React.forwardRef(({ variant, children, className, ...props }, ref) => {
    return (
        <Tooltip
            {...props}
            ref={ref}
            className={classnames(className, `ml-tooltip-${variant}`)}
            aria-atomic="true"
        >
            { children }
        </Tooltip>
    );
});

MLTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    variant: PropTypes.oneOf(['success']), // Only "success" is supported for now
};

MLTooltip.defaultProps = {
    variant: 'success',
};

export default MLTooltip;
